export const ARTICLE_CATEGORIES = [
  "hormones_cycle",
  "fertility_preconception",
  "pcos_endocrine",
  "pregnancy_postpartum",
  "perimenopause_menopause",
  "symptoms_signals",
  "tests_results",
  "food_nutrition",
  "supplements_micronutrients",
  "mental_emotional",
  "lifestyle_foundations",
  "hiya_guides",
] as const;

export type ArticleCategory = (typeof ARTICLE_CATEGORIES)[number];

export const CATEGORY_LABELS: Record<ArticleCategory, string> = {
  hormones_cycle: "Hormones & Cycle",
  fertility_preconception: "Fertility & Preconception",
  pcos_endocrine: "PCOS & Endocrine Conditions",
  pregnancy_postpartum: "Pregnancy & Postpartum",
  perimenopause_menopause: "Perimenopause & Menopause",
  symptoms_signals: "Symptoms & Signals",
  tests_results: "Tests & Results Explained",
  food_nutrition: "Food & Nutrition",
  supplements_micronutrients: "Supplements & Micronutrients",
  mental_emotional: "Mental & Emotional Health",
  lifestyle_foundations: "Lifestyle & Foundations",
  hiya_guides: "Hiya Guides",
};

export const DURATION_VALUES = [5, 10, 15, 20, 25, 30] as const;
export type DurationValue = (typeof DURATION_VALUES)[number];

export interface ArticleBlock {
  type: "text" | "heading" | "button";
  content: string;
  link?: string;
}

export interface Article {
  id: string;
  title: string;
  category: ArticleCategory;
  read_time_minutes: number;
  cover_url: string | null;
  cover_thumb_url: string | null;
  body: ArticleBlock[];
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface EditorBlock {
  id: string;
  type: "heading" | "text" | "button";
  content: string;
  link?: string;
}

export interface ArticleCreatePayload {
  title: string;
  category: ArticleCategory;
  read_time_minutes: number;
  body: ArticleBlock[];
}

export interface ArticleUpdatePayload {
  title?: string;
  category?: ArticleCategory;
  read_time_minutes?: number;
  body?: ArticleBlock[];
}
